'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/radio/style/css.js
// module id = 578
// module chunks = 0